<template>
  <div>
    <v-app-bar
      app
      id="navbar-top"
      color=" white black--text v-app-bar--is-scrolled"
      fixed
      style="z-index: 100"
      clipped-left
      light
    >
      <!-- <v-app-bar-nav-icon></v-app-bar-nav-icon> -->
      <v-img
        id="sidebar-logo"
        max-height="55px"
        max-width="78px"
        src="@/img/img-logo-only.png"
        to="dashboard"
        lazy-src="@/img/img-logo-only.png"
        contain
        style="margin-right: 5px; cursor: pointer"
        @click="redirectToHome"
      ></v-img>
      <!-- <v-app-bar-nav-icon  > 
      
     </v-app-bar-nav-icon> -->
      <span id="site-name1">Easy</span>
      <span id="site-name2">Planner</span>

      <v-spacer></v-spacer>
      <!-- <NavbarMobile></NavbarMobile> -->
      <span id="nav-company-name">{{ this.companyInfo.ragioneSociale }} </span>

      <v-spacer></v-spacer>

      <v-menu style="z-index: 1000000">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            large
            color="navbarbg"
            class="pr-0 pl-1"
            right
            text
            v-bind="attrs"
            v-on="on"
          >
            <h3
              class="font-weight-medium text-right"
              style="text-transform: capitalize"
            >
              {{ currentUser.username }} &nbsp;
              <v-avatar
                v-bind:color="
                  currentUser.colore != null ? currentUser.colore : '#777'
                "
                size="32"
              >
                <v-icon dark class="font-weight-medium white--text text-right">
                  mdi-account-circle
                </v-icon>
              </v-avatar>
              <v-icon
                v-bind:color="
                  currentUser.colore != null ? currentUser.colore : '#777'
                "
              >
                mdi-menu-down
              </v-icon>
            </h3>
          </v-btn>
        </template>
        <v-list dark>
          <v-list-item-group v-model="selectedItem">
            <v-list-item
              :key="item.value"
              :value="item.value"
              v-for="item in items"
            >
              <v-list-item-icon
                ><v-icon>{{ item.icon }}</v-icon></v-list-item-icon
              >
              <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>
    </v-app-bar>
  </div>
</template>

<style>
#navbar-top span#site-name1 {
  font-size: 24px;
  font-weight: 300;
}
#navbar-top span#site-name2 {
  color: black;
  font-size: 24px;
  font-weight: 800;
  width: 200px;
}
#menu {
  padding-right: 20px;
}
</style>
<script>
import SessionHelper from "../../utils/SessionHelper";
export default {
  data: () => ({
    _currentUser: null,
    items: [
      {
        text: "Informazioni personali",
        icon: "mdi-account-circle",
        value: "personalInfo",
      },
      {
        text: "Agenda",
        icon: "mdi-calendar",
        value: "mieiInterventi",
      },
      {
        text: "Esci",
        icon: "mdi-logout-variant",
        value: "logout",
      },
    ],
  }),
  methods: {
    CurrentUserChanged(user) {
      console.debug("userChanged", user);
      this._currentUser = user;
    },
    redirectToHome() {
      this.$router.push("/Dashboard");
    },
  },
  computed: {
    selectedItem: {
      get() {
        return null;
      },
      set(val) {
        console.debug(val);
        switch (val) {
          case "logout":
            SessionHelper.Logoff(this.$route.params.companyAlias);
            break;
          case "mieiInterventi":
            this.$router.push({ name: "agenda-viewer" });
            break;
          case "personalInfo":
            this.$router.push({
              name: "user-profile",
              params: {
                companyAlias: this.$route.params.companyAlias,
                hashId: this.currentUser.hashId,
              },
            });
            break;
        }
      },
    },
    companyInfo() {
      if (localStorage.companyInfo != null)
        return JSON.parse(localStorage.companyInfo);
      else return { ragioneSociale: "---" };
    },
    currentUser: {
      get: function () {
        console.debug("stò rileggendo i dati");
        if (this._currentUser == null) {
          if (localStorage.currentUser != null)
            return JSON.parse(localStorage.currentUser);
          else return { username: "---" };
        } else return this._currentUser;
      },

      set: function (value) {
        console.debug("stò aggiornando l'utente");
        this._currentUser = value;
      },
    },
    CompanyFullAddress() {
      if (this.companyInfo != "---")
        return (
          this.companyInfo.indirizzo +
          " - " +
          this.companyInfo.citta +
          " (" +
          this.companyInfo.provincia +
          ")"
        );
      else return "---";
    },
  },
};
</script>
